import styled, { css } from "styled-components/macro";

export const StyledDiv = styled.div<{ border?: boolean; align?: string }>`
  width: 100%;
  margin: 0 auto;
  text-align: ${(props) => props.align || "start"};

  ${(props) =>
    props.border &&
    css`
      border-radius: ${(props) => props.theme.sizes.borderRadius};
      border: 1px solid ${(props) => props.theme.colors.border};
    `}
`;

export const StyledPlus = styled.span`
  font-size: 24px;
  margin-right: 0.5rem;
`;

export const TextPlainSpecific = styled.p`
  width: 100%;
  margin: 0 auto;
  font-size: ${(props) => props.theme.font.size};
  word-break: break-all;
  white-space: normal;

  color: ${(props) => props.theme.colors.text};
  @media ${(props) => props.theme.media.phone} {
    font-size: 14px;
  }
`;